const STORAGE_KEY = "management-roguelike:audio-mix";

export const DEFAULT_BGM_VOLUME = 0.36;
export const DEFAULT_SE_VOLUME = 1;

type AudioMix = { bgm: number; se: number };

function clampVolume(value: number): number {
  return Math.min(1, Math.max(0, value));
}

function load(): AudioMix {
  if (typeof localStorage === "undefined") return { bgm: DEFAULT_BGM_VOLUME, se: DEFAULT_SE_VOLUME };
  try {
    const saved: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "null");
    if (saved && typeof saved === "object" && "bgm" in saved && "se" in saved
      && typeof saved.bgm === "number" && typeof saved.se === "number") {
      return { bgm: clampVolume(saved.bgm), se: clampVolume(saved.se) };
    }
  } catch {
    // A malformed preference should never prevent the game from starting.
  }
  return { bgm: DEFAULT_BGM_VOLUME, se: DEFAULT_SE_VOLUME };
}

let mix = load();

function persist(): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(mix));
  } catch {
    // Private browsing or full storage: keep the in-memory setting for this session.
  }
}

export function getBgmVolume(): number {
  return mix.bgm;
}

export function getSeVolume(): number {
  return mix.se;
}

export function setBgmVolume(volume: number): number {
  mix = { ...mix, bgm: clampVolume(volume) };
  persist();
  return mix.bgm;
}

export function setSeVolume(volume: number): number {
  mix = { ...mix, se: clampVolume(volume) };
  persist();
  return mix.se;
}
